import { useMemo } from 'react';
import { getEnvironment } from '../feature-flags';
import { Environment } from '../feature-flags/types';

export function useEnvironment() {
  const environment: Environment = useMemo(() => {
    return getEnvironment();
  }, []);

  const isProduction = environment === 'prod';
  const isDevelopment = environment === 'dev';
  const isStaging = environment === 'stg';

  return { environment, isProduction, isDevelopment, isStaging };
}
